import { getBaseUrl } from './lib/GetBaseUrl'

const baseUrl = getBaseUrl()

const apiPath = {
  getHomePage: baseUrl + `ManageHomePageSection/GetNewHomePageSection`,
  getLendingPage: baseUrl + `ManageLendingPageSection/GetNewLendingPageSection`,
  getStaticPages: baseUrl + 'ManageStaticPages',
  getStaticPagesDetails: baseUrl + 'ManageStaticPages/byId',
  getStaticPagesDetailsBySearch: baseUrl + 'ManageStaticPages/search',
  getMenu: baseUrl + 'ManageHomePageSection/GetMenu',
  getTopMenu: baseUrl + 'TopHeaderMenu/search',
  getOrders: baseUrl + 'User/Order/bysearchText',
  getOrder: baseUrl + 'User/Order/byId',
  getUserProduct: baseUrl + 'user/Product',
  getUserProductAPlusContent:
    baseUrl + 'ManageProductSection/GetNewProductSection',
  getUserProductFaqs: baseUrl + 'FAQ/search',
  getUserBlogs: baseUrl + 'Blog',
  getUserRatingReview: baseUrl + 'user/ProductRating/bySearch',
  getUserProductDetails: baseUrl + 'user/Product/NewProductDetails',
  getNewUserProductList: baseUrl + 'user/Product/NewProductList',
  getProductFilter: baseUrl + 'user/Product/ProductFilters',
  getBrands: baseUrl + 'MainCategory/GetCategoryWiseBrands',
  getBrandsById: baseUrl + 'Brand',
  getProductDetailsMetadata: baseUrl + 'user/Product/seo',
  getProductListMetadata: baseUrl + 'user/Product/ProductSeo',
  getCategory: baseUrl + 'MainCategory/GetAllCategory',
  getBrandMetadata: baseUrl + 'user/Product/BrandSeo',
  getComparisonProduct: baseUrl + 'user/Product/productComparison'
}

export default apiPath
